export default __webpack_public_path__ + "static/media/france.9e64d70e.webp";